<input matInput 
	(input)="searchItem()"
	(focusin)="setFocusIn()"
	(focusout)="setFocusOut($event)"
	#baseInput
	[matAutocompleteConnectedTo]="connectedFormField()"
	[formControl]="formControl" 
	[matAutocomplete]="auto"
	(blur)="markTouched()"/>
<mat-autocomplete #auto="matAutocomplete" 
	class="select__panel--surface"
	[displayWith]="displayItem"
	[root]="auto.panel"
	appIntersectionObserver 
	requireSelection
	(intersecting)="loadItems()"
	(optionSelected)="markTouched()"
		rootMargin="0px 0px 20% 0px" >
		@if(items()?.data; as items){
			@for (item of items; track item[identifierField()]; let last = $last) {
				@if(last){
					<mat-option
						[value]="item"
						appObserve>{{item[valueField()]}}</mat-option>
				}
				@else {
					<mat-option
						[value]="item">
						{{item[valueField()]}}</mat-option>
				}
			}
	}
</mat-autocomplete>